import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import portalApi, { apiError } from './portalApi';
import { T } from './portalTheme';
import { AuthLayout, Spinner, Icon, IC, Button } from './PortalWidgets';
import { usePortalAuth } from '../../context/PortalAuthContext';

// /questionnaire/portal/verify?token=<token> -- the link inside the verification email.
// Verifying the token is itself proof of owning the inbox, so a successful verify also logs the
// recipient straight in (the backend returns a portal access token in the same response) and
// lands them on their dashboard, where every questionnaire sent to their email is listed.
export default function PortalVerify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const { loginWithToken } = usePortalAuth();
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!token) { setError('This verification link is missing its code.'); return; }
    portalApi.get('/v1/questionnaire-responses/portal/verify', { params: { token } })
      .then(({ data }) => {
        loginWithToken(data.access_token, data.account);
        setDone(true);
        setTimeout(() => navigate('/questionnaire/portal/dashboard', { replace: true }), 900);
      })
      .catch(err => setError(apiError(err, 'This verification link is invalid or has expired.')));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <AuthLayout>
      <div style={{ textAlign: 'center' }}>
        {error ? (
          <>
            <span style={{ width: 56, height: 56, borderRadius: 16, background: T.redBg, color: T.red, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
              <Icon d={IC.alert} size={26} />
            </span>
            <div style={{ fontSize: 22, fontWeight: 800, color: T.ink }}>We couldn't verify your email</div>
            <div style={{ fontSize: 14, color: T.muted, marginTop: 10, lineHeight: 1.6 }}>{error}</div>
            <div style={{ fontSize: 13.5, color: T.muted, marginTop: 18, lineHeight: 1.6 }}>
              If you already verified, just sign in. Otherwise open the original invitation email and create your account again to get a fresh link.
            </div>
            <div style={{ marginTop: 24 }}>
              <Button full onClick={() => navigate('/questionnaire/portal/login')}>Go to sign in</Button>
            </div>
          </>
        ) : done ? (
          <>
            <span style={{ width: 56, height: 56, borderRadius: 16, background: T.greenBg, color: T.green, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
              <Icon d={IC.checkCircle} size={26} />
            </span>
            <div style={{ fontSize: 22, fontWeight: 800, color: T.ink }}>Email verified</div>
            <div style={{ fontSize: 14, color: T.muted, marginTop: 10 }}>Taking you to your questionnaires…</div>
          </>
        ) : (
          <>
            <div style={{ marginBottom: 20 }}><Spinner size={32} /></div>
            <div style={{ fontSize: 18, fontWeight: 700, color: T.ink }}>Verifying your email…</div>
          </>
        )}
      </div>
    </AuthLayout>
  );
}
